(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbh-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('BBHWelcomeDialog');
    if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;
    const form = dialog.querySelector('form');
    const result = dialog.querySelector('[data-bbh-result]')?.dataset.bbhResult;
    const key = 'bbh_welcome_offer_v1';
    const pendingKey = 'bbh_welcome_pending';
    const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
    const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
    const pending = Number(read('sessionStorage', pendingKey) || 0);
    const returned = location.hash === '#BBHWelcomeForm' || Date.now() - pending < 180000;
    const open = () => { if (!dialog.open) dialog.showModal(); };
    const dismiss = () => {
      if (result !== 'success') write('localStorage', key, String(Date.now() + 7 * 86400000));
      dialog.close();
    };
    dialog.querySelectorAll('[data-bbh-dismiss]').forEach(button => button.addEventListener('click', dismiss));
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dismiss(); } });
    form.addEventListener('submit', () => write('sessionStorage', pendingKey, String(Date.now())));
    if (result && returned) {
      if (result === 'success') write('localStorage', key, 'subscribed');
      write('sessionStorage', pendingKey, '0');
      open();
      return;
    }
    if (result) return;
    const saved = read('localStorage', key);
    if (saved === 'subscribed' || Number(saved) > Date.now()) return;
    window.setTimeout(() => {
      if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) return;
      if (document.activeElement?.matches('input, textarea, select')) return;
      open();
    }, 8000);
  })();
  } catch(e) { console.error(e); }
})();

})();
